import { baseConfig } from "config";
import { getAccessToken } from "services/auth";
import {
	AccountType,
	RegistrationState
} from "store/features/registration/types";
import { Requester } from "./requester";

export const getBankAccounts = async (partner_id: string | null = "") => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/partner/${partner_id}/bank-account/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const getBankAccount = async (
	partnerId: string | null = "",
	bankAccountId: string | null = ""
) => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/partner/${partnerId}/bank-account/${bankAccountId}/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result) => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export interface BankAccountResponse {
	id: string;
}

export const createOrUpdateBankAccount = async (
	partner_id: string | null,
	bankAccount_id: string | null,
	bankAccount: AccountType
) => {
	const access_token = await getAccessToken();

	const requestData = { ...bankAccount };

	if (requestData.account_number === "") requestData.account_number = undefined;
	if (requestData.branch_id === "") requestData.branch_id = undefined;
	if (requestData.bank_id === "" || requestData.bank_id === undefined)
		requestData.bank_id = undefined;

	if (!bankAccount_id) {
		return Requester.post({
			url: `${baseConfig.baseURL}/partner/${partner_id}/bank-account/`,
			token: `${access_token}`,
			tokenType: "Bearer",
			body: requestData,
			success: (result): BankAccountResponse => {
				return result;
			},
			error: (error) => {
				throw error;
			}
		});
	}

	return Requester.put({
		url: `${baseConfig.baseURL}/partner/${partner_id}/bank-account/${bankAccount_id}/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		body: requestData,
		success: (result): BankAccountResponse => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

/*
export const saveBankAccount = async (
	personalData: RegistrationState,
	id: string | null = ""
) => {
	const access_token = await getAccessToken();

	const requestData = { ...personalData };

	return Requester.put({
		url: `${baseConfig.baseURL}/bankAccount/${id}/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		body: requestData,
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};
*/

export const deleteBankAccount = async (
	partner_id: string | null = "",
	id: string | null = ""
) => {
	const access_token = await getAccessToken();

	return Requester.delete({
		url: `${baseConfig.baseURL}/partner/${partner_id}/bank-account/${id}/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};
